import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, NavLink, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import LoadingButton from '@mui/lab/LoadingButton'
import LockIcon from '@mui/icons-material/Lock'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Error, Spinner } from '../../common/Error';
import Hero from '../../common/Hero'
import {
  doPasswordReset,
  selectUser,
} from './authSlice';
//import styles from './Auth.module.css';

export const PasswordReset = () => {
  const user = useSelector(selectUser)
  const { loading, error, success } = useSelector((state) => state.auth.password_reset)
  const getMeLoading = useSelector((state) => state.auth.me.loading)
  const dispatch = useDispatch()
  const [ searchParams, setSearchParams ] = useSearchParams() 
  const passwordResetToken = searchParams.get('passwordResetToken') || localStorage.getItem('password_reset_token')
  console.log('[PasswordReset]', passwordResetToken)
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required')
      .min(4, 'Password must be at least 4 characters')
      .max(32, 'Password must not exceed 32 characters'),
    confirmPassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('password'), null], 'Confirm Password does not match'),
  })

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      passwordResetToken,
      password: '',
      confirmPassword: ''
    },
    resolver: yupResolver(validationSchema)
  })
  const navigate = useNavigate()

  useEffect(() => {
    // redirect user to login page if password reset successful
    if (success) navigate('/login')
    // redirect authenticated user to profile screen
    // if (user && user.verified) navigate('/rooms')
  }, [navigate, success])

  const submitForm = (data) => {
    if (data.password !== data.confirmPassword) {
      alert('Password mismatch')
    }
    dispatch(doPasswordReset({
      new_password: data.password,
      password_reset_token: data.passwordResetToken}))
  }

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Hero />
        <Typography component="h1" variant="h6">
          Set your Babel Chat password
        </Typography>
        <Box component='form' noValidate='noValidate' onSubmit={handleSubmit(submitForm)}>
          <TextField
            id='password'
            autoComplete='new-password'
            type='password'
            name='password'
            {...register('password')}
            required
            fullWidth
            margin='normal'
            label='Password'
            error={errors.password ? true : false}
            helperText={errors.password?.message}
          />
          <TextField
            id='confirmPassword'
            autoComplete='new-password'
            type='password'
            name='confirmPassword'
            {...register('confirmPassword')}
            required
            fullWidth
            margin='normal'
            label='Confirm Password'
            error={errors.confirmPassword ? true : false}
            helperText={errors.confirmPassword?.message}
          />
          <div className='form-group'>
            <input
              type='hidden'
              className='form-input'
              {...register('passwordResetToken')}
              required
            />
          </div>
          <LoadingButton
            size='large'
            type='submit'
            fullWidth
            variant='contained'
            loading={loading}
            loadingPosition="start"
            startIcon={<LockIcon />}
            sx={{ mt: 4, mb: 4 }}
          >
            Set Password
          </LoadingButton>
        </Box>
        <Link component={NavLink} to={'/login'} variant="body1">
          Remembered your old one? Log in
        </Link>
      </Box>
    </Container>
  )
}
